import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'column',
  standalone: true,
})
export class ColumnPipe implements PipeTransform {
  transform(column: string): string {
    return column === 'source_of_income_codes'
      ? 'Source of Income'
      : column === 'remittance_purpose_codes'
        ? 'Purpose'
        : column === 'transfer_types'
          ? 'Transfer Type'
          : column === 'service_level_delivery_speed_codes'
            ? 'Service Level'
            : 'Payment Method';
  }
}
